namespace GeniuzPOS.PosShift {
    export namespace LogFuctionLvAppService {
        export const baseUrl = 'PosShift/LogFuctionLvApp';

        export declare function Create(request: Serenity.SaveRequest<LogFuctionLvAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LogFuctionLvAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LogFuctionLvAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LogFuctionLvAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/LogFuctionLvApp/Create",
            Update = "PosShift/LogFuctionLvApp/Update",
            Delete = "PosShift/LogFuctionLvApp/Delete",
            Retrieve = "PosShift/LogFuctionLvApp/Retrieve",
            List = "PosShift/LogFuctionLvApp/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LogFuctionLvAppService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
